const Page404 = () => {
    return <p>
               404 not found
           </p>
}

export default Page404;
